<template>
    <div class="mb-3">
        <div style="white-space: normal;" v-html="output"></div>
    </div>
</template>

<script>
export default {
    props: {
        content: {
            type: String,
            default: ''
        }
    },

    computed: {
        output() {
            let text = this.content;
            
            text = this.textHtml(text);
            text = this.specials(text);
            return text;
        }
    },

    methods: {
        textHtml: function(text) {
            const tlds = '(?:com|org|net|info|museum|edu|gov|mil|us|school)';
            const domain = `(?:[\\w\\d\\-_]+\\.)?[\\w\\d\\-_]+\\.${tlds}`;
            
            //Standardize newlines
            text = text.replace(/(?:\r\n|\r|\n)/g, "\n");

            // Break string into paragraphs
            text = text.replace(/([^\n]+)/gms, '<p>$1</p>');

            // Fix single quoted attributes in HTML
            text = text.replace(/=(?:&quot;)(.*?)(?:&quot;)/g, "='$1'");

            // Fix double quoted attributes in HTML
            text = text.replace(/=(?:&dquot;)(.*?)(?:&dquot;)/g, '="$1"');

            // Allow certain HTML tags
            text = text.replace(/&lt;(\/?(?:a\b|b\b|blockqote\b|br\b|cite\b|code\b|dd\b|del\s|dl\b|dt\b|em\b|h[1-6]\b|hr\b|i\b|img\b|li\b|ol\b|p\b|pre\b|q\b|s\b|samp\b|small\b|span\b|strike\b|strong\b|sub\b|sup\b|table\b|tbody\b|td\b|tfoot\b|th\b|thead\b|tr\b|tt\b|u\b|ul\b).*?)&gt;/gi, '<$1>');

            // Add "https://" to any domain that isn't prefaced with "http://", "https://", any 
            // word character (A-Z, a-z, 0-9, and _), or an "@" symbol.
            let re = new RegExp(String.raw`(?<!(?:https?:\/\/|[\w@\.]))(${domain})`, 'gi');
            text = text.replace(re, 'https://$1');
            
            // Encode URLs from the text if it is not proceded by a word character or quote. This should prevent encoding 
            // URLs that are already in <a> or <img> elements.
            re = new RegExp(String.raw`(?<![\w"'])(https?://|ftp://)(${domain})((?:/[\w\-\.~:/\?#\[\]@!\$'\(\)\*\+,;%=]*)?)`, 'gi');
            text = text.replace(re, '<a href="$1$2$3" class="dark" target="_blank">$2</a>');

            // Create mailto links for any found email addresses
            re = new RegExp(String.raw`\b([\w\.\-\+]+@${domain})\b`, 'gi');
            text = text.replace(re, '<a href="mailto:$1"><i class="far fa-envelope me-2"></i>$1</a>');

            // Create tel links for any found phone numbers
            text = text.replace(/\b(\d{3})[\.\-](\d{3})[\.\-](\d{4})\b/g, '<a href="tel:$1$2$3">$1-$2-$3</a>');

            return text;
        },


        /**
        * Replace certain special characters with their HTML
        * counterparts
        * 
        * @param string $text
        * @return string
        */
        specials: function(text) {
            // left single smart quote
            text = text.replace(/\xE2\x80\x98/g, '&#x2018;');

            // right single smart quote
            text = text.replace(/\xE2\x80\x99/g, '&#x2019;');

            // left double smart quote
            text = text.replace(/\xE2\x80\x9C/g, '&#x201c;');

            // right double smart quote
            text = text.replace(/\xE2\x80\x9D/g, '&#x201d;');
            
            // ndash            
            text = text.replace(/\xE2\x80\x93/g, '&#x2013;');
            
            // mdash
            text = text.replace(/\xE2\x80\x94/g, '&#x2014;');

            return text;
        }
    }
}
</script>

<style scoped>
img {
    max-width: 100% !important;
}

iframe {
    display: none;
}
</style>